import { RouteRecordRaw } from "vue-router";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";

const routes: Array<RouteRecordRaw> = [
  {
    path: "",
    name: "costCenterView",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.COST_CENTER.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.COST_CENTER.PERMISSIONS,
    },
    component: () => import("@/modules/CostCenter/views/CostCenter.vue"),
  },
];

export default routes;
